import { FilterCriteriaAlternative } from '../../http/clients/dls/DlsClientAlternative';
import { FilterCriteriaDlsSearch } from '../../http/clients/dls/DlsClientSearch';
import { UnifiedTeaserFilterCriteria } from '../../http/clients/dls/DlsClientTeaser';
import { splitModelIdentifier } from '../SplitData';
import { createVanConfiguration } from '../VansConfiguration';

export function createFilterCriteriaString(
  filter: FilterCriteriaDlsSearch | UnifiedTeaserFilterCriteria | FilterCriteriaAlternative,
): string {
  const filterEntries = Object.entries(filter)
    .filter(([_, value]) => value && value !== '')
    .map(([key, value]) => `${key}=${value}`);
  return filterEntries.join('|');
}

export function getVansFilterCriteria(
  filter: FilterCriteriaDlsSearch | UnifiedTeaserFilterCriteria | FilterCriteriaAlternative,
) {
  const vansConfig = createVanConfiguration(filter);
  const body =
    vansConfig.bodyType === null ? splitModelIdentifier(filter.modelIdentifier?.[0] ?? '').body : vansConfig.bodyType;

  return createFilterCriteriaString({
    ...filter,
    bodyType: body,
    modelIdentifier: vansConfig.modelIdentifier ?? '',
    fuelType: vansConfig.fuelType,
  });
}
